import { v4 as uuidv4 } from "uuid";

export const NODE_OK_DEFAULT_TEXT = `
Es scheint, als ob alles in Ordnung wäre. Bei weiteren Fragen helfe ich Ihnen gerne weiter!
`

export const DEFAULT_SUPPORT_NODE_REGEX = /^SUP0+\s*(\D.*)?$/i;

export function DEFAULT_SUPPORT_NODE() {
    return {
        id: `default-support-${uuidv4()}`,
        domainIdentifier: "SUP0",
        type: "support",
        content: "Es scheint, als ob ich Ihnen nicht weiterhelfen kann. Bitte kontaktieren Sie unseren Support"
    }
}